define('plugin/package/collection/PackageInstanceCollection',['require','lib/collection/ServerPaginatedCollection','plugin/package/model/PackageInstanceModel'],function (require) {

    var FilterableCollection = require('lib/collection/ServerPaginatedCollection');
    var PackageInstanceModel = require('plugin/package/model/PackageInstanceModel');

    /**
     * Package instance collection
     *
     * @class PackageInstanceCollection
     */
    return FilterableCollection.extend({

        url: '/ext/package/instance/',
        model: PackageInstanceModel

    });

});
